export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigDecimal: any;
  DateTime: any;
  JSON: any;
  _Any: any;
};

export type AddLocationIdInput = {
  locationId: Scalars['ID'];
  productInstanceId: Scalars['String'];
};

export type AddLocationIdPayload = {
  __typename?: 'AddLocationIdPayload';
  success?: Maybe<Scalars['Boolean']>;
};

export type AddLocationLatLongInput = {
  latitude: Scalars['Float'];
  locationId: Scalars['String'];
  longitude: Scalars['Float'];
};

export type AddLocationLatLongPayload = {
  __typename?: 'AddLocationLatLongPayload';
  success: Scalars['Boolean'];
  updatedPartySummaries?: Maybe<Array<PartySummary>>;
  updatedProductInstanceIds?: Maybe<Array<Scalars['String']>>;
};

export type AddMigratedEbiProductInstanceInput = {
  errorDescription?: InputMaybe<Scalars['String']>;
  phase?: InputMaybe<Scalars['String']>;
  productInstanceId: Scalars['ID'];
  sai: Scalars['String'];
};

export type AddMigratedEbiProductInstancePayload = {
  __typename?: 'AddMigratedEbiProductInstancePayload';
  reason?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type AddMigratedSmbProductInstanceInput = {
  errorDescription?: InputMaybe<Scalars['String']>;
  productInstanceId: Scalars['ID'];
};

export type AddMigratedSmbProductInstancePayload = {
  __typename?: 'AddMigratedSmbProductInstancePayload';
  reason?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type AddOrUpdateOtherLocationInput = {
  locationId: Scalars['String'];
  otherLocation: OtherLocationInput;
};

export type AddOrUpdateOtherLocationPayload = {
  __typename?: 'AddOrUpdateOtherLocationPayload';
  location: Location;
  updatedPartySummaries?: Maybe<Array<PartySummary>>;
  updatedProductInstanceIds?: Maybe<Array<Scalars['String']>>;
};

export type AddProductInstanceGroupMembersInput = {
  members: Array<Scalars['ID']>;
  productInstanceGroupId: Scalars['ID'];
};

export type AddProductInstanceGroupMembersPayload = {
  __typename?: 'AddProductInstanceGroupMembersPayload';
  membersAdded: Array<Scalars['ID']>;
  membersNotAdded?: Maybe<Array<MemberError>>;
  productInstanceGroupId: Scalars['ID'];
};

export type AdditionalAttributesInput = {
  name: Scalars['String'];
  value: Scalars['String'];
  valueType?: InputMaybe<Scalars['String']>;
};

export type Address = {
  __typename?: 'Address';
  addressLine?: Maybe<Array<Scalars['String']>>;
  countryCode: Scalars['String'];
  municipality?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  addressLine?: InputMaybe<Array<Scalars['String']>>;
  countryCode: Scalars['String'];
  municipality?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
};

export type BatchUpdateMigratedEbiProductInstanceInput = {
  errorDescription?: InputMaybe<Scalars['String']>;
  phase?: InputMaybe<Scalars['String']>;
  productInstanceIds?: InputMaybe<Array<Scalars['ID']>>;
  sais?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<Scalars['String']>;
};

export type BatchUpdateMigratedEbiProductInstancePayload = {
  __typename?: 'BatchUpdateMigratedEbiProductInstancePayload';
  reason?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type BatchUpdateMigratedSmbProductInstanceInput = {
  errorDescription?: InputMaybe<Scalars['String']>;
  productInstanceIds?: InputMaybe<Array<Scalars['ID']>>;
  status?: InputMaybe<Scalars['String']>;
};

export type BatchUpdateMigratedSmbProductInstancePayload = {
  __typename?: 'BatchUpdateMigratedSmbProductInstancePayload';
  reason?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC',
}

export type Characteristic = {
  __typename?: 'Characteristic';
  name: Scalars['String'];
  tokenizationUrl?: Maybe<Scalars['String']>;
  value: Scalars['String'];
  valueType?: Maybe<Scalars['String']>;
};

export type CharacteristicInput = {
  name: Scalars['String'];
  tokenizationUrl?: InputMaybe<Scalars['String']>;
  value: Scalars['String'];
  valueType?: InputMaybe<Scalars['String']>;
};

export type CharacteristicsFilter = {
  name: Scalars['String'];
  value: Scalars['String'];
};

export type CommandOptionsInput = {
  name: Scalars['String'];
  value: Scalars['String'];
  valueType?: InputMaybe<Scalars['String']>;
};

export type CommandOptionsPayload = {
  __typename?: 'CommandOptionsPayload';
  name: Scalars['String'];
  value: Scalars['String'];
  valueType?: Maybe<Scalars['String']>;
};

export enum CommandState {
  Created = 'CREATED',
  Failed = 'FAILED',
  Running = 'RUNNING',
  Succeeded = 'SUCCEEDED',
}

/**
 * Standards followed:
 *   - UPU S42 Addressing Standard http://www.upu.int/en/activities/addressing/s42-standard.html
 */
export type Coordinates = {
  __typename?: 'Coordinates';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

export type CoordinatesInput = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type CreateCommandInput = {
  commandName: Scalars['String'];
  kind?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Array<InputMaybe<CommandOptionsInput>>>;
  productInstanceId?: InputMaybe<Scalars['ID']>;
};

export type CreateCommandPayload = {
  __typename?: 'CreateCommandPayload';
  commandId: Scalars['ID'];
};

/** CreateLocationId Request */
export type CreateLocationIdInput = {
  forceCreation?: InputMaybe<Scalars['Boolean']>;
  location: LocationInput;
};

/** CreateLocationId Response */
export type CreateLocationIdPayload = {
  __typename?: 'CreateLocationIdPayload';
  locationId: Scalars['ID'];
};

export type CreateProductInstanceGroupInput = {
  characteristics?: InputMaybe<Array<InputMaybe<CharacteristicInput>>>;
  members?: InputMaybe<Array<Scalars['ID']>>;
  name: Scalars['String'];
  type: GroupType;
};

export type CreateProductInstanceGroupPayload = {
  __typename?: 'CreateProductInstanceGroupPayload';
  membersNotAdded?: Maybe<Array<MemberError>>;
  productInstanceGroup: ProductInstanceGroup;
};

export type Currency = {
  __typename?: 'Currency';
  alphabeticCode?: Maybe<Scalars['String']>;
  majorUnitSymbol?: Maybe<Scalars['String']>;
  minorUnits?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  numericCode?: Maybe<Scalars['Int']>;
};

export type CurrencyInput = {
  alphabeticCode?: InputMaybe<Scalars['String']>;
  majorUnitSymbol?: InputMaybe<Scalars['String']>;
  minorUnits?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  numericCode?: InputMaybe<Scalars['Int']>;
};

export type CustomerReln = Relationship & {
  __typename?: 'CustomerReln';
  getProductInstances?: Maybe<GetProductInstancesPayload>;
  relnId: Scalars['ID'];
};

export type DeactivateProductInstanceGroupInput = {
  productInstanceGroupId: Scalars['ID'];
};

export type DeactivateProductInstanceGroupPayload = {
  __typename?: 'DeactivateProductInstanceGroupPayload';
  productInstanceGroupId: Scalars['ID'];
};

/** DeleteCharacteristics */
export type DeleteCharacteristicsInput = {
  characteristics?: InputMaybe<Array<CharacteristicInput>>;
  error?: InputMaybe<ErrorInput>;
  productInstanceId: Scalars['ID'];
};

export type DeleteCharacteristicsPayload = {
  __typename?: 'DeleteCharacteristicsPayload';
  error?: Maybe<ErrorPayload>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * General Section
 *   - Shared by more than one
 */
export enum DirectionEnum {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type EndProductInstanceRelationshipInput = {
  productInstanceRelationshipId: Scalars['ID'];
};

export type EndProductInstanceRelationshipPayload = {
  __typename?: 'EndProductInstanceRelationshipPayload';
  success: Scalars['String'];
};

export type EquipmentUpdateInput = {
  characteristics?: InputMaybe<Array<CharacteristicInput>>;
  newDescription?: InputMaybe<Scalars['String']>;
  newName?: InputMaybe<Scalars['String']>;
  newProductTypeId?: InputMaybe<Scalars['ID']>;
  productInstanceId: Scalars['ID'];
};

export type ErrorInput = {
  category: Scalars['String'];
  code: Scalars['String'];
  errorInstanceId: Scalars['ID'];
  message?: InputMaybe<Scalars['String']>;
  severity?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
};

export type ErrorPayload = {
  __typename?: 'ErrorPayload';
  category: Scalars['String'];
  code: Scalars['String'];
  errorInstanceId: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  severity?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
};

export type EventAttributes = {
  __typename?: 'EventAttributes';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type EventCharacteristic = {
  __typename?: 'EventCharacteristic';
  name: Scalars['String'];
  value: Scalars['String'];
  valueType?: Maybe<Scalars['String']>;
};

export type EventError = {
  __typename?: 'EventError';
  category: Scalars['String'];
  code: Scalars['String'];
  errorInstanceId: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  severity?: Maybe<Scalars['String']>;
  timestamp: Scalars['DateTime'];
};

export type EventHeader = {
  __typename?: 'EventHeader';
  eventSource: Scalars['String'];
  eventType: Scalars['String'];
  executionId: Scalars['ID'];
  timestamp: Scalars['DateTime'];
};

export type EventPartySummary = {
  __typename?: 'EventPartySummary';
  name: Scalars['String'];
  partySummaryId?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

export type EventProductInstance = {
  __typename?: 'EventProductInstance';
  characteristics?: Maybe<Array<Maybe<EventCharacteristic>>>;
  creationTimestamp: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  kind: Scalars['String'];
  lastUpdateTimestamp: Scalars['DateTime'];
  locationIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  name: Scalars['String'];
  partySummary?: Maybe<Array<EventPartySummary>>;
  prices?: Maybe<Array<Maybe<Price>>>;
  productInstanceId: Scalars['ID'];
  productTypeId: Scalars['ID'];
  state: Scalars['String'];
};

export type EventProductInstanceRelationship = {
  __typename?: 'EventProductInstanceRelationship';
  destinationProductInstance: EventProductInstance;
  endTimestamp?: Maybe<Scalars['DateTime']>;
  productInstanceRelationshipId: Scalars['ID'];
  productRelationshipType: ProductRelationshipType;
  sourceProductInstance: EventProductInstance;
  startTimestamp: Scalars['DateTime'];
};

/** findProductInstancesInProductInstanceGroup */
export type FindProductInstancesInProductInstanceGroupInput = {
  characteristics_contains?: InputMaybe<Array<CharacteristicsFilter>>;
  characteristics_not_contains?: InputMaybe<Array<CharacteristicsFilter>>;
  kind?: InputMaybe<Scalars['String']>;
  kind_in?: InputMaybe<Array<Scalars['String']>>;
  kind_not_in?: InputMaybe<Array<Scalars['String']>>;
  /** The limit must be between 1 and 1500. The default value is 50. */
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  productInstanceGroupId: Scalars['ID'];
  state_in?: InputMaybe<Array<LifecycleStateType>>;
  state_not_in?: InputMaybe<Array<LifecycleStateType>>;
};

export type FindProductInstancesInProductInstanceGroupPayload = {
  __typename?: 'FindProductInstancesInProductInstanceGroupPayload';
  productInstanceGroup?: Maybe<ProductInstanceGroup>;
  productInstances?: Maybe<Array<ProductInstance>>;
};

export type GetAddOnsBundlesEquipmentInput = {
  kind?: InputMaybe<Scalars['String']>;
  kind_in?: InputMaybe<Array<Scalars['String']>>;
  kind_not_in?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<OrderByInput>;
  partySummary: PartySummaryInput;
  state_in?: InputMaybe<Array<InputMaybe<LifecycleStateType>>>;
  state_not_in?: InputMaybe<Array<InputMaybe<LifecycleStateType>>>;
};

export type GetAddOnsBundlesEquipmentPayload = {
  __typename?: 'GetAddOnsBundlesEquipmentPayload';
  addOnProductInstances?: Maybe<Array<ProductInstance>>;
  bundleProductInstances?: Maybe<Array<ProductInstance>>;
  equipmentProductInstances?: Maybe<Array<ProductInstance>>;
  productInstanceRelationships?: Maybe<Array<ProductInstanceRelationship>>;
  rootProductInstance?: Maybe<ProductInstance>;
};

/** GetCharacteristics */
export type GetCharacteristicsInput = {
  characteristicNames: Array<Scalars['String']>;
  productInstanceId: Scalars['ID'];
};

export type GetCharacteristicsPayload = {
  __typename?: 'GetCharacteristicsPayload';
  characteristics?: Maybe<Array<Maybe<Characteristic>>>;
  productInstanceId: Scalars['ID'];
};

export type GetCommandInput = {
  commandId: Scalars['ID'];
};

export type GetCommandNamesInput = {
  kind?: InputMaybe<Scalars['String']>;
  productInstanceId?: InputMaybe<Scalars['ID']>;
};

export type GetCommandNamesPayload = {
  __typename?: 'GetCommandNamesPayload';
  commandNames?: Maybe<Array<Scalars['String']>>;
};

export type GetCommandPayload = {
  __typename?: 'GetCommandPayload';
  commandName: Scalars['String'];
  kind?: Maybe<Scalars['String']>;
  options?: Maybe<Array<Maybe<CommandOptionsPayload>>>;
  productInstanceId?: Maybe<Scalars['ID']>;
  result?: Maybe<Scalars['JSON']>;
  status: CommandState;
};

/** Input for getGovernmentSiteDetailsByState query */
export type GetGovernmentSiteDetailsByStateInput = {
  /** Defaults to `100` if not specified, and max is `100` */
  limit?: InputMaybe<Scalars['Int']>;
  /** If provided, will fetch the next set of results based on this token */
  nextToken?: InputMaybe<Scalars['String']>;
  /** Product instance states to include when retrieving PIs for a site. If not provided, all states will be included. */
  productInstanceStatesIn?: InputMaybe<Array<LifecycleStateType>>;
  productInstanceStatesNotIn?: InputMaybe<Array<LifecycleStateType>>;
  /** The state of the site to filter by, e.g. 'COMMISSIONED', 'DECOMMISSIONED' */
  state: Scalars['String'];
};

/**
 * Returns the details of government sites
 * If more pages are available, nextToken will be provided
 */
export type GetGovernmentSiteDetailsByStatePayload = {
  __typename?: 'GetGovernmentSiteDetailsByStatePayload';
  /** If there are more results, this will be provided to fetch the next set */
  nextToken?: Maybe<Scalars['String']>;
  sites: Array<SiteDetails>;
};

/** GetLocation */
export type GetLocationInput = {
  locationId: Scalars['ID'];
  readonly?: InputMaybe<Scalars['Boolean']>;
};

export type GetLocationPayload = {
  __typename?: 'GetLocationPayload';
  location: Location;
};

/** GetLocationTimestamp */
export type GetLocationTimestampsInput = {
  endTimestamp_gt?: InputMaybe<Scalars['DateTime']>;
  endTimestamp_lt?: InputMaybe<Scalars['DateTime']>;
  productInstanceId: Scalars['ID'];
  startTimestamp_gt?: InputMaybe<Scalars['DateTime']>;
  startTimestamp_lt?: InputMaybe<Scalars['DateTime']>;
};

export type GetLocationTimestampsPayload = {
  __typename?: 'GetLocationTimestampsPayload';
  locationTimestamps?: Maybe<Array<Maybe<LocationTimestamp>>>;
  productInstanceId: Scalars['ID'];
};

/** getMacAddressesForProductInstanceIds */
export type GetMacAddressesForProductInstanceIdsInput = {
  includeColons?: InputMaybe<Scalars['Boolean']>;
  productInstanceIds: Array<Scalars['ID']>;
};

export type GetMacAddressesForProductInstanceIdsPayload = {
  __typename?: 'GetMacAddressesForProductInstanceIdsPayload';
  macAddresses: Array<PiToMacAddress>;
};

export type GetMetricInput = {
  kind?: InputMaybe<Scalars['String']>;
  metricName: Scalars['String'];
  options?: InputMaybe<Array<MetricsOptionsInput>>;
  productInstanceId?: InputMaybe<Scalars['ID']>;
};

export type GetMetricNamesInput = {
  kind?: InputMaybe<Scalars['String']>;
  productInstanceId?: InputMaybe<Scalars['ID']>;
};

export type GetMetricNamesPayload = {
  __typename?: 'GetMetricNamesPayload';
  metricNames?: Maybe<Array<Scalars['String']>>;
};

export type GetMetricPayload = {
  __typename?: 'GetMetricPayload';
  kind?: Maybe<Scalars['String']>;
  metricName: Scalars['String'];
  options?: Maybe<Array<Maybe<MetricsOptions>>>;
  productInstanceId?: Maybe<Scalars['ID']>;
  results?: Maybe<Scalars['JSON']>;
};

export type GetMigratedEbiProductsInput = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  phase?: InputMaybe<Scalars['String']>;
  productInstanceId?: InputMaybe<Scalars['String']>;
  sai?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type GetMigratedEbiProductsPayload = {
  __typename?: 'GetMigratedEbiProductsPayload';
  migratedEbiProducts?: Maybe<Array<MigratedEbiProductInstance>>;
};

export type GetMigratedSmbProductsInput = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  productInstanceId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type GetMigratedSmbProductsPayload = {
  __typename?: 'GetMigratedSmbProductsPayload';
  migratedSmbProducts?: Maybe<Array<MigratedSmbProductInstance>>;
};

/** GetPiiLocationId */
export type GetPiiLocationInput = {
  countryCode?: InputMaybe<Scalars['String']>;
};

export type GetPiiLocationPayload = {
  __typename?: 'GetPiiLocationPayload';
  sThreeBucketUrl?: Maybe<Scalars['String']>;
};

/** getPortfolioByPiCharacteristics */
export type GetPortfolioByPiCharacteristicsInput = {
  characteristics: Array<CharacteristicInput>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']>;
};

export type GetPortfolioByPiCharacteristicsPayload = {
  __typename?: 'GetPortfolioByPiCharacteristicsPayload';
  portfolioItems: Array<GetPortfolioProductInstance>;
  portfolioRelationships: Array<GetPortfolioProductInstanceRelationships>;
};

/** GetPortfolioBySiteId */
export type GetPortfolioBySiteIdInput = {
  includeDeactivated?: InputMaybe<Scalars['Boolean']>;
  siteId: Scalars['ID'];
};

export type GetPortfolioBySiteIdPayload = {
  __typename?: 'GetPortfolioBySiteIdPayload';
  portfolioItems: Array<GetPortfolioProductInstance>;
  portfolioRelationships: Array<GetPortfolioProductInstanceRelationships>;
  site?: Maybe<Site>;
  siteId?: Maybe<Scalars['ID']>;
};

/** GetPortfolio */
export type GetPortfolioInput = {
  includeDeactivated?: InputMaybe<Scalars['Boolean']>;
  productInstanceId: Scalars['ID'];
};

export type GetPortfolioPayload = {
  __typename?: 'GetPortfolioPayload';
  portfolioItems: Array<GetPortfolioProductInstance>;
  portfolioRelationships: Array<GetPortfolioProductInstanceRelationships>;
};

export type GetPortfolioProductInstance = {
  __typename?: 'GetPortfolioProductInstance';
  characteristics?: Maybe<Array<Characteristic>>;
  isRoot: Scalars['Boolean'];
  kind?: Maybe<Scalars['String']>;
  locationIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  productInstanceId: Scalars['ID'];
  productTypeId: Scalars['ID'];
  state: LifecycleStateType;
};

export type GetPortfolioProductInstanceRelationships = {
  __typename?: 'GetPortfolioProductInstanceRelationships';
  destination: GetPortfolioRelationshipProductInstance;
  source: GetPortfolioRelationshipProductInstance;
};

export type GetPortfolioRelationshipProductInstance = {
  __typename?: 'GetPortfolioRelationshipProductInstance';
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** GetProductInstanceEquipment */
export type GetProductInstanceEquipmentInput = {
  characteristics_contains?: InputMaybe<Array<InputMaybe<CharacteristicsFilter>>>;
  order_by?: InputMaybe<OrderByInput>;
  productInstanceId: Scalars['ID'];
  state_in?: InputMaybe<Array<InputMaybe<LifecycleStateType>>>;
  timestamp_gte?: InputMaybe<Scalars['DateTime']>;
  timestamp_lte?: InputMaybe<Scalars['DateTime']>;
};

export type GetProductInstanceEquipmentPayload = {
  __typename?: 'GetProductInstanceEquipmentPayload';
  productInstanceRelationships?: Maybe<Array<Maybe<ProductInstanceRelationship>>>;
  productInstances?: Maybe<Array<Maybe<ProductInstance>>>;
};

/** GetProductInstanceEvents */
export type GetProductInstanceEventsInput = {
  action_in?: InputMaybe<Array<Scalars['String']>>;
  action_not_in?: InputMaybe<Array<Scalars['String']>>;
  caller_in?: InputMaybe<Array<Scalars['String']>>;
  caller_not_in?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<OrderByInput>;
  productInstanceId: Scalars['ID'];
  request?: InputMaybe<Scalars['JSON']>;
  response?: InputMaybe<Scalars['JSON']>;
  timestamp_gte?: InputMaybe<Scalars['DateTime']>;
  timestamp_lte?: InputMaybe<Scalars['DateTime']>;
};

export type GetProductInstanceEventsPayload = {
  __typename?: 'GetProductInstanceEventsPayload';
  events: Array<Maybe<ProductInstanceChangeEvent>>;
};

/** GetProductInstanceGroupEvents */
export type GetProductInstanceGroupEventsInput = {
  action_in?: InputMaybe<Array<Scalars['String']>>;
  action_not_in?: InputMaybe<Array<Scalars['String']>>;
  caller_in?: InputMaybe<Array<Scalars['String']>>;
  caller_not_in?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<OrderByInput>;
  productInstanceGroupId: Scalars['ID'];
  timestamp_gte?: InputMaybe<Scalars['DateTime']>;
  timestamp_lte?: InputMaybe<Scalars['DateTime']>;
};

export type GetProductInstanceGroupEventsPayload = {
  __typename?: 'GetProductInstanceGroupEventsPayload';
  events: Array<ProductInstanceGroupEvent>;
};

export type GetProductInstanceGroupsInput = {
  characteristics_contains?: InputMaybe<Array<CharacteristicsFilter>>;
  group_state_in?: InputMaybe<Array<GroupState>>;
  group_state_not_in?: InputMaybe<Array<GroupState>>;
  member?: InputMaybe<Scalars['ID']>;
  productInstanceGroupId?: InputMaybe<Scalars['ID']>;
};

export type GetProductInstanceGroupsPayload = {
  __typename?: 'GetProductInstanceGroupsPayload';
  productInstanceGroups: Array<ProductInstanceGroup>;
};

/** GetProductInstanceRelationships Request */
export type GetProductInstanceRelationshipsInput = {
  destinationProductInstanceFilters?: InputMaybe<ProductInstanceFilters>;
  destinationProductInstanceId?: InputMaybe<Scalars['ID']>;
  endTimestamp_lt?: InputMaybe<Scalars['DateTime']>;
  productInstanceRelationshipId?: InputMaybe<Scalars['ID']>;
  productRelationshipType?: InputMaybe<ProductRelationshipType>;
  sourceProductInstanceFilters?: InputMaybe<ProductInstanceFilters>;
  sourceProductInstanceId?: InputMaybe<Scalars['ID']>;
  startTimestamp_gt?: InputMaybe<Scalars['DateTime']>;
};

/** GetProductInstanceRelationships Response */
export type GetProductInstanceRelationshipsPayload = {
  __typename?: 'GetProductInstanceRelationshipsPayload';
  productInstanceRelationships?: Maybe<Array<Maybe<ProductInstanceRelationship>>>;
};

export type GetProductInstancesAggregatesInput = {
  calculateTotal?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Scalars['String']>;
  kind_in?: InputMaybe<Array<Scalars['String']>>;
  kind_not_in?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<OrderByInput>;
  partySummary: PartySummaryInput;
  productInstanceRelationships?: InputMaybe<ProductInstanceRelationshipsFilterInput>;
  state_in?: InputMaybe<Array<InputMaybe<LifecycleStateType>>>;
  state_not_in?: InputMaybe<Array<InputMaybe<LifecycleStateType>>>;
};

export type GetProductInstancesAggregatesPayload = {
  __typename?: 'GetProductInstancesAggregatesPayload';
  locations?: Maybe<Array<LocationAndId>>;
  productInstanceGroups?: Maybe<Array<ProductInstanceGroup>>;
  productInstanceRelationships?: Maybe<Array<ProductInstanceRelationship>>;
  productInstances?: Maybe<Array<ProductInstance>>;
  totalProducts?: Maybe<Scalars['Int']>;
};

/** GetProductInstances Request */
export type GetProductInstancesInput = {
  calculateTotal?: InputMaybe<Scalars['Boolean']>;
  characteristics_contains?: InputMaybe<Array<InputMaybe<CharacteristicsFilter>>>;
  characteristics_not_contains?: InputMaybe<Array<InputMaybe<CharacteristicsFilter>>>;
  kind?: InputMaybe<Scalars['String']>;
  kind_in?: InputMaybe<Array<Scalars['String']>>;
  kind_not_in?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['String']>;
  locationShortCode?: InputMaybe<ShortCodeInput>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<OrderByInput>;
  partySummary?: InputMaybe<Array<InputMaybe<PartySummaryInput>>>;
  productInstanceId?: InputMaybe<Scalars['ID']>;
  productInstanceRelationships?: InputMaybe<ProductInstanceRelationshipsFilterInput>;
  readonly?: InputMaybe<Scalars['Boolean']>;
  retryAttempts_gt?: InputMaybe<Scalars['Int']>;
  retryAttempts_lt?: InputMaybe<Scalars['Int']>;
  retryTimestamp_gt?: InputMaybe<Scalars['DateTime']>;
  retryTimestamp_lt?: InputMaybe<Scalars['DateTime']>;
  state_in?: InputMaybe<Array<InputMaybe<LifecycleStateType>>>;
  state_not_in?: InputMaybe<Array<InputMaybe<LifecycleStateType>>>;
};

/** GetProductInstances Response */
export type GetProductInstancesPayload = {
  __typename?: 'GetProductInstancesPayload';
  productInstanceRelationships?: Maybe<Array<Maybe<ProductInstanceRelationship>>>;
  productInstances?: Maybe<Array<Maybe<ProductInstance>>>;
  requestedStates?: Maybe<Array<RequestedState>>;
  totalProducts?: Maybe<Scalars['Int']>;
};

/** GetReconnectPortfolioInput Request */
export type GetReconnectPortfolioInput = {
  productInstanceId?: InputMaybe<Scalars['ID']>;
};

/** GetReconnectPortfolioInput Response */
export type GetReconnectPortfolioPayload = {
  __typename?: 'GetReconnectPortfolioPayload';
  reconnectPortfolioItems?: Maybe<Array<Maybe<ReconnectPortfolioProductInstance>>>;
};

/** getRelnIdsFromMacAddressesInput */
export type GetRootPisFromMacAddressesInput = {
  macAddresses: Array<Scalars['String']>;
};

export type GetRootPisFromMacAddressesPayload = {
  __typename?: 'GetRootPisFromMacAddressesPayload';
  rootProducts: Array<RootProduct>;
};

/** GetSuspendStatus */
export type GetSuspendStatusInput = {
  productInstanceId: Scalars['ID'];
};

export type GetSuspendStatusPayload = {
  __typename?: 'GetSuspendStatusPayload';
  suspendTimestamp?: Maybe<Scalars['DateTime']>;
  suspendType?: Maybe<Scalars['String']>;
  suspended: Scalars['Boolean'];
};

export enum GroupState {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED',
}

export enum GroupType {
  DefaultGroupType = 'DEFAULT_GROUP_TYPE',
  GovernmentServiceSiteGroup = 'GOVERNMENT_SERVICE_SITE_GROUP',
  ServiceGroup = 'SERVICE_GROUP',
  WholesaleServiceGroup = 'WHOLESALE_SERVICE_GROUP',
}

export enum LifecycleStateType {
  Accepted = 'ACCEPTED',
  Accepting = 'ACCEPTING',
  AcceptingError = 'ACCEPTING_ERROR',
  Activating = 'ACTIVATING',
  ActivatingError = 'ACTIVATING_ERROR',
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Canceling = 'CANCELING',
  CancelingError = 'CANCELING_ERROR',
  Creating = 'CREATING',
  CreatingError = 'CREATING_ERROR',
  Deactivated = 'DEACTIVATED',
  Deactivating = 'DEACTIVATING',
  DeactivatingError = 'DEACTIVATING_ERROR',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING',
  ProcessingError = 'PROCESSING_ERROR',
  Reactivating = 'REACTIVATING',
  ReactivatingError = 'REACTIVATING_ERROR',
  Reconnecting = 'RECONNECTING',
  ReconnectingError = 'RECONNECTING_ERROR',
  Suspended = 'SUSPENDED',
  Suspending = 'SUSPENDING',
  SuspendingError = 'SUSPENDING_ERROR',
}

export type Location = {
  __typename?: 'Location';
  address: Address;
  coordinates?: Maybe<Coordinates>;
  /** @deprecated otherLocations is now an array, use otherLocations field */
  otherLocation?: Maybe<OtherLocation>;
  otherLocations?: Maybe<Array<OtherLocation>>;
  shortCode?: Maybe<Scalars['String']>;
};

export type LocationAndId = {
  __typename?: 'LocationAndId';
  location: Location;
  locationId: Scalars['ID'];
};

export type LocationInput = {
  address: AddressInput;
  coordinates?: InputMaybe<CoordinatesInput>;
  otherLocations?: InputMaybe<Array<OtherLocationInput>>;
};

export type LocationTimestamp = {
  __typename?: 'LocationTimestamp';
  endTimestamp?: Maybe<Scalars['DateTime']>;
  location: Location;
  startTimestamp?: Maybe<Scalars['DateTime']>;
};

export type Metrics = {
  __typename?: 'Metrics';
  name: Scalars['String'];
  options?: Maybe<Array<Maybe<MetricsOptions>>>;
};

export type MetricsInput = {
  name: Scalars['String'];
  options?: InputMaybe<Array<InputMaybe<MetricsOptionsInput>>>;
};

export type MetricsOptions = {
  __typename?: 'MetricsOptions';
  name: Scalars['String'];
  value: Scalars['String'];
  valueType?: Maybe<Scalars['String']>;
};

/** GetMetrics */
export type MetricsOptionsInput = {
  name: Scalars['String'];
  value: Scalars['String'];
  valueType?: InputMaybe<Scalars['String']>;
};

export type MigratedEbiProductInstance = {
  __typename?: 'MigratedEbiProductInstance';
  errorDescription?: Maybe<Scalars['String']>;
  insertedTimestamp?: Maybe<Scalars['DateTime']>;
  phase: Scalars['String'];
  productInstanceId: Scalars['ID'];
  sai: Scalars['String'];
  status: Scalars['String'];
  updateDate?: Maybe<Scalars['DateTime']>;
};

export type MigratedSmbProductInstance = {
  __typename?: 'MigratedSmbProductInstance';
  errorDescription?: Maybe<Scalars['String']>;
  insertedTimestamp?: Maybe<Scalars['DateTime']>;
  productInstanceId: Scalars['ID'];
  status: Scalars['String'];
  updateDate?: Maybe<Scalars['DateTime']>;
};

export type Money = {
  __typename?: 'Money';
  currency?: Maybe<Currency>;
  value?: Maybe<Scalars['BigDecimal']>;
};

export type MoneyInput = {
  currency: CurrencyInput;
  value?: InputMaybe<Scalars['BigDecimal']>;
};

/** :: Mutation Definitions :: */
export type Mutation = {
  __typename?: 'Mutation';
  addLocationId?: Maybe<AddLocationIdPayload>;
  addLocationLatLong?: Maybe<AddLocationLatLongPayload>;
  addMigratedEbiProductInstance?: Maybe<AddMigratedEbiProductInstancePayload>;
  addMigratedSmbProductInstance?: Maybe<AddMigratedSmbProductInstancePayload>;
  addOrUpdateOtherLocation?: Maybe<AddOrUpdateOtherLocationPayload>;
  addProductInstanceGroupMembers?: Maybe<AddProductInstanceGroupMembersPayload>;
  batchUpdateMigratedEbiProductInstance?: Maybe<BatchUpdateMigratedEbiProductInstancePayload>;
  batchUpdateMigratedSmbProductInstance?: Maybe<BatchUpdateMigratedSmbProductInstancePayload>;
  createCommand?: Maybe<CreateCommandPayload>;
  createLocationId?: Maybe<CreateLocationIdPayload>;
  createProductInstanceGroup?: Maybe<CreateProductInstanceGroupPayload>;
  deactivateProductInstanceGroup?: Maybe<DeactivateProductInstanceGroupPayload>;
  deleteCharacteristics?: Maybe<DeleteCharacteristicsPayload>;
  endProductInstanceRelationship?: Maybe<EndProductInstanceRelationshipPayload>;
  insertProductInstanceRelationship?: Maybe<ProductInstanceRelationshipUpsertPayload>;
  onboardProductInstances?: Maybe<OnboardProductInstancesPayload>;
  overrideProductInstanceLifecycleState?: Maybe<UpdateProductInstanceLifecycleStatePayload>;
  publishLifecycleStateEvent?: Maybe<PublishLifecycleStateEventPayload>;
  reactivateProduct?: Maybe<ReactivateProductPayload>;
  removeOtherLocation?: Maybe<RemoveOtherLocationPayload>;
  removeProductInstanceGroupMembers?: Maybe<RemoveProductInstanceGroupMembersPayload>;
  removeRelationshipEndTimestamp?: Maybe<RemoveRelationshipEndTimestampPayload>;
  requestDeleteCharacteristic?: Maybe<RequestDeleteCharacteristicPayload>;
  requestProductInstanceLifecycleStateChange?: Maybe<RequestProductInstanceLifecycleStateChangePayload>;
  requestRelatedProductStateChange?: Maybe<RequestRelatedProductStateChangePayload>;
  requestUpsertCharacteristic?: Maybe<UpsertCharacteristicsPayload>;
  requestUpsertGroupCharacteristic?: Maybe<UpsertCharacteristicsPayload>;
  updateAddressLines?: Maybe<UpdateAddressLinesPayload>;
  updateCharacteristicList?: Maybe<UpsertCharacteristicsPayload>;
  updateCoordinateLatLong?: Maybe<UpdateCoordinateLatLongPayload>;
  updateEquipment?: Maybe<UpdateEquipmentPayload>;
  updateInstallationAttributes?: Maybe<UpdateInstallationAttributesPayload>;
  updateLocationIds?: Maybe<UpdateLocationIdsPayload>;
  updateMigratedEbiProductInstance?: Maybe<UpdateMigratedEbiProductInstancePayload>;
  updateMigratedSmbProductInstance?: Maybe<UpdateMigratedSmbProductInstancePayload>;
  updateProductInstanceGroup?: Maybe<UpdateProductInstanceGroupPayload>;
  updateProductInstanceLifecycleState?: Maybe<UpdateProductInstanceLifecycleStatePayload>;
  updateServiceLocationAddress?: Maybe<UpdateServiceLocationAddressPayload>;
  upsertCharacteristics?: Maybe<UpsertCharacteristicsPayload>;
  upsertProductInstanceGroupCharacteristics?: Maybe<UpsertProductInstanceGroupCharacteristicsPayload>;
  upsertProductInstances?: Maybe<UpsertProductInstancesPayload>;
};

/** :: Mutation Definitions :: */
export type MutationAddLocationIdArgs = {
  input?: InputMaybe<AddLocationIdInput>;
};

/** :: Mutation Definitions :: */
export type MutationAddLocationLatLongArgs = {
  input?: InputMaybe<AddLocationLatLongInput>;
};

/** :: Mutation Definitions :: */
export type MutationAddMigratedEbiProductInstanceArgs = {
  input?: InputMaybe<AddMigratedEbiProductInstanceInput>;
};

/** :: Mutation Definitions :: */
export type MutationAddMigratedSmbProductInstanceArgs = {
  input?: InputMaybe<AddMigratedSmbProductInstanceInput>;
};

/** :: Mutation Definitions :: */
export type MutationAddOrUpdateOtherLocationArgs = {
  input?: InputMaybe<AddOrUpdateOtherLocationInput>;
};

/** :: Mutation Definitions :: */
export type MutationAddProductInstanceGroupMembersArgs = {
  input?: InputMaybe<AddProductInstanceGroupMembersInput>;
};

/** :: Mutation Definitions :: */
export type MutationBatchUpdateMigratedEbiProductInstanceArgs = {
  input?: InputMaybe<BatchUpdateMigratedEbiProductInstanceInput>;
};

/** :: Mutation Definitions :: */
export type MutationBatchUpdateMigratedSmbProductInstanceArgs = {
  input?: InputMaybe<BatchUpdateMigratedSmbProductInstanceInput>;
};

/** :: Mutation Definitions :: */
export type MutationCreateCommandArgs = {
  input?: InputMaybe<CreateCommandInput>;
};

/** :: Mutation Definitions :: */
export type MutationCreateLocationIdArgs = {
  input?: InputMaybe<CreateLocationIdInput>;
};

/** :: Mutation Definitions :: */
export type MutationCreateProductInstanceGroupArgs = {
  input?: InputMaybe<CreateProductInstanceGroupInput>;
};

/** :: Mutation Definitions :: */
export type MutationDeactivateProductInstanceGroupArgs = {
  input?: InputMaybe<DeactivateProductInstanceGroupInput>;
};

/** :: Mutation Definitions :: */
export type MutationDeleteCharacteristicsArgs = {
  input?: InputMaybe<DeleteCharacteristicsInput>;
};

/** :: Mutation Definitions :: */
export type MutationEndProductInstanceRelationshipArgs = {
  input?: InputMaybe<EndProductInstanceRelationshipInput>;
};

/** :: Mutation Definitions :: */
export type MutationInsertProductInstanceRelationshipArgs = {
  input?: InputMaybe<ProductInstanceRelationshipInput>;
};

/** :: Mutation Definitions :: */
export type MutationOnboardProductInstancesArgs = {
  input?: InputMaybe<OnboardProductInstancesInput>;
};

/** :: Mutation Definitions :: */
export type MutationOverrideProductInstanceLifecycleStateArgs = {
  input?: InputMaybe<UpdateProductInstanceLifecycleStateInput>;
};

/** :: Mutation Definitions :: */
export type MutationPublishLifecycleStateEventArgs = {
  input?: InputMaybe<PublishLifecycleStateEventInput>;
};

/** :: Mutation Definitions :: */
export type MutationReactivateProductArgs = {
  input?: InputMaybe<ReactivateProductInput>;
};

/** :: Mutation Definitions :: */
export type MutationRemoveOtherLocationArgs = {
  input?: InputMaybe<RemoveOtherLocationInput>;
};

/** :: Mutation Definitions :: */
export type MutationRemoveProductInstanceGroupMembersArgs = {
  input?: InputMaybe<RemoveProductInstanceGroupMembersInput>;
};

/** :: Mutation Definitions :: */
export type MutationRemoveRelationshipEndTimestampArgs = {
  input?: InputMaybe<RemoveRelationshipEndTimestampInput>;
};

/** :: Mutation Definitions :: */
export type MutationRequestDeleteCharacteristicArgs = {
  input?: InputMaybe<RequestDeleteCharacteristicInput>;
};

/** :: Mutation Definitions :: */
export type MutationRequestProductInstanceLifecycleStateChangeArgs = {
  input?: InputMaybe<RequestProductInstanceLifecycleStateChangeInput>;
};

/** :: Mutation Definitions :: */
export type MutationRequestRelatedProductStateChangeArgs = {
  input?: InputMaybe<RequestRelatedProductStateChangeInput>;
};

/** :: Mutation Definitions :: */
export type MutationRequestUpsertCharacteristicArgs = {
  input?: InputMaybe<RequestUpsertCharacteristicInput>;
};

/** :: Mutation Definitions :: */
export type MutationRequestUpsertGroupCharacteristicArgs = {
  input?: InputMaybe<RequestUpsertGroupCharacteristicInput>;
};

/** :: Mutation Definitions :: */
export type MutationUpdateAddressLinesArgs = {
  input?: InputMaybe<UpdateAddressLinesInput>;
};

/** :: Mutation Definitions :: */
export type MutationUpdateCharacteristicListArgs = {
  input?: InputMaybe<UpdateCharacteristicListInput>;
};

/** :: Mutation Definitions :: */
export type MutationUpdateCoordinateLatLongArgs = {
  input?: InputMaybe<UpdateCoordinateLatLongInput>;
};

/** :: Mutation Definitions :: */
export type MutationUpdateEquipmentArgs = {
  input?: InputMaybe<UpdateEquipmentInput>;
};

/** :: Mutation Definitions :: */
export type MutationUpdateInstallationAttributesArgs = {
  input?: InputMaybe<UpdateInstallationAttributesInput>;
};

/** :: Mutation Definitions :: */
export type MutationUpdateLocationIdsArgs = {
  input?: InputMaybe<UpdateLocationIdsInput>;
};

/** :: Mutation Definitions :: */
export type MutationUpdateMigratedEbiProductInstanceArgs = {
  input?: InputMaybe<UpdateMigratedEbiProductInstanceInput>;
};

/** :: Mutation Definitions :: */
export type MutationUpdateMigratedSmbProductInstanceArgs = {
  input?: InputMaybe<UpdateMigratedSmbProductInstanceInput>;
};

/** :: Mutation Definitions :: */
export type MutationUpdateProductInstanceGroupArgs = {
  input?: InputMaybe<UpdateProductInstanceGroupInput>;
};

/** :: Mutation Definitions :: */
export type MutationUpdateProductInstanceLifecycleStateArgs = {
  input?: InputMaybe<UpdateProductInstanceLifecycleStateInput>;
};

/** :: Mutation Definitions :: */
export type MutationUpdateServiceLocationAddressArgs = {
  input?: InputMaybe<UpdateServiceLocationAddressInput>;
};

/** :: Mutation Definitions :: */
export type MutationUpsertCharacteristicsArgs = {
  input?: InputMaybe<UpsertCharacteristicsInput>;
};

/** :: Mutation Definitions :: */
export type MutationUpsertProductInstanceGroupCharacteristicsArgs = {
  input?: InputMaybe<UpsertProductInstanceGroupCharacteristicsInput>;
};

/** :: Mutation Definitions :: */
export type MutationUpsertProductInstancesArgs = {
  input?: InputMaybe<UpsertProductInstancesInput>;
};

export type OnboardProductInstanceRelationshipInput = {
  destinationProductInstanceId: Scalars['ID'];
  endTimestamp?: InputMaybe<Scalars['DateTime']>;
  productInstanceRelationshipId: Scalars['ID'];
  productRelationshipType: ProductRelationshipType;
  sourceProductInstanceId: Scalars['ID'];
  startTimestamp: Scalars['DateTime'];
};

/** OnboardProductInstances Request */
export type OnboardProductInstancesInput = {
  delta?: InputMaybe<Scalars['Boolean']>;
  no_events?: InputMaybe<Scalars['Boolean']>;
  productInstanceRelationships?: InputMaybe<Array<InputMaybe<OnboardProductInstanceRelationshipInput>>>;
  productInstances: Array<InputMaybe<PsmOnboardProductInstanceInput>>;
};

/** OnboardProductInstances Response */
export type OnboardProductInstancesPayload = {
  __typename?: 'OnboardProductInstancesPayload';
  productInstanceRelationships?: Maybe<Array<Maybe<ProductInstanceRelationshipUpsertPayload>>>;
  productInstances?: Maybe<Array<Maybe<ProductInstance>>>;
};

export type Order = {
  __typename?: 'Order';
  customerRelationshipId: Scalars['ID'];
  orderId: Scalars['ID'];
  productInstanceIds?: Maybe<Array<Scalars['ID']>>;
  productInstances?: Maybe<Array<Maybe<ProductInstance>>>;
};

export type OrderByInput = {
  direction: DirectionEnum;
  field: Scalars['String'];
};

export type OtherLocation = {
  __typename?: 'OtherLocation';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type OtherLocationInput = {
  name: Scalars['String'];
  value: Scalars['String'];
};

/** ProductInstance is a configured instance of a ProductType */
export type PartySummary = {
  __typename?: 'PartySummary';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type PartySummaryInput = {
  name: Scalars['String'];
  value: Scalars['String'];
};

export type PiToMacAddress = {
  __typename?: 'PiToMacAddress';
  macAddress?: Maybe<Scalars['String']>;
  productInstanceId: Scalars['ID'];
};

export type Price = {
  __typename?: 'Price';
  amount?: Maybe<Money>;
  characteristics?: Maybe<Array<Maybe<PriceCharacteristic>>>;
  description?: Maybe<Scalars['String']>;
  kind: Scalars['String'];
  name: Scalars['String'];
  percentage?: Maybe<Scalars['Float']>;
  priceCharacteristics?: Maybe<Array<Maybe<PriceCharacteristic>>>;
  recurrence: Scalars['String'];
  unitOfMeasure?: Maybe<Scalars['String']>;
};

/**
 * Schemas taken from OfferManagement:
 *   Currency
 *   Money
 *   Price
 */
export type PriceCharacteristic = {
  __typename?: 'PriceCharacteristic';
  name: Scalars['String'];
  value?: Maybe<Scalars['String']>;
  valueType?: Maybe<Scalars['String']>;
};

export type PriceCharacteristicInput = {
  name: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
  valueType?: InputMaybe<Scalars['String']>;
};

export type PriceInput = {
  amount: MoneyInput;
  characteristics?: InputMaybe<Array<InputMaybe<PriceCharacteristicInput>>>;
  description?: InputMaybe<Scalars['String']>;
  kind: Scalars['String'];
  name: Scalars['String'];
  percentage?: InputMaybe<Scalars['Float']>;
  recurrence: Scalars['String'];
  unitOfMeasure?: InputMaybe<Scalars['String']>;
};

export type Product = {
  __typename?: 'Product';
  id: Scalars['ID'];
  productInstance?: Maybe<ProductInstance>;
};

export type ProductInstance = {
  __typename?: 'ProductInstance';
  characteristics?: Maybe<Array<Characteristic>>;
  creationTimestamp: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  kind: Scalars['String'];
  lastUpdateTimestamp: Scalars['DateTime'];
  locationIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** @deprecated Use locationIds with getLocation instead. */
  locations?: Maybe<Array<Maybe<Location>>>;
  name: Scalars['String'];
  partySummary?: Maybe<Array<PartySummary>>;
  prices?: Maybe<Array<Maybe<Price>>>;
  productInstanceGroup?: Maybe<ProductInstanceGroup>;
  productInstanceId: Scalars['ID'];
  productTypeId: Scalars['ID'];
  retryAttempts?: Maybe<Scalars['Int']>;
  retryTimestamp?: Maybe<Scalars['DateTime']>;
  state: LifecycleStateType;
};

export type ProductInstanceCharacteristicsArgs = {
  excludeCharacteristics?: InputMaybe<Array<Scalars['String']>>;
  includeCharacteristics?: InputMaybe<Array<Scalars['String']>>;
};

export type ProductInstanceChangeEvent = {
  __typename?: 'ProductInstanceChangeEvent';
  action: Scalars['String'];
  caller: Scalars['String'];
  executionId?: Maybe<Scalars['String']>;
  request: Scalars['JSON'];
  response?: Maybe<Scalars['JSON']>;
  status?: Maybe<Scalars['String']>;
  timestamp: Scalars['DateTime'];
};

export type ProductInstanceCharacteristicsUpdateEvent = {
  __typename?: 'ProductInstanceCharacteristicsUpdateEvent';
  eventData: ProductInstanceCharacteristicsUpdateEventData;
  eventHeader: EventHeader;
};

export type ProductInstanceCharacteristicsUpdateEventData = {
  __typename?: 'ProductInstanceCharacteristicsUpdateEventData';
  error?: Maybe<EventError>;
  productInstance?: Maybe<EventProductInstance>;
  updatedCharacteristics?: Maybe<Array<Maybe<EventCharacteristic>>>;
};

export type ProductInstanceFilterInput = {
  kind_in?: InputMaybe<Array<Scalars['String']>>;
  kind_not_in?: InputMaybe<Array<Scalars['String']>>;
};

export type ProductInstanceFilters = {
  characteristics_contains?: InputMaybe<Array<InputMaybe<CharacteristicsFilter>>>;
  kind?: InputMaybe<Scalars['String']>;
  state_in?: InputMaybe<Array<InputMaybe<LifecycleStateType>>>;
  state_not_in?: InputMaybe<Array<InputMaybe<LifecycleStateType>>>;
};

export type ProductInstanceGroup = {
  __typename?: 'ProductInstanceGroup';
  characteristics?: Maybe<Array<Maybe<Characteristic>>>;
  members?: Maybe<Array<Scalars['ID']>>;
  name: Scalars['String'];
  productInstanceGroupId: Scalars['ID'];
  state: GroupState;
  type: GroupType;
};

export type ProductInstanceGroupEvent = {
  __typename?: 'ProductInstanceGroupEvent';
  action: Scalars['String'];
  caller: Scalars['String'];
  executionId?: Maybe<Scalars['String']>;
  request: Scalars['JSON'];
  response?: Maybe<Scalars['JSON']>;
  timestamp: Scalars['DateTime'];
};

export type ProductInstanceInput = {
  characteristics?: InputMaybe<Array<InputMaybe<CharacteristicInput>>>;
  description?: InputMaybe<Scalars['String']>;
  kind: Scalars['String'];
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  locations?: InputMaybe<Array<InputMaybe<LocationInput>>>;
  name: Scalars['String'];
  partySummary?: InputMaybe<Array<InputMaybe<PartySummaryInput>>>;
  prices?: InputMaybe<Array<InputMaybe<PriceInput>>>;
  productInstanceId: Scalars['ID'];
  productTypeId: Scalars['ID'];
};

export type ProductInstanceLifecycleEvent = {
  __typename?: 'ProductInstanceLifecycleEvent';
  eventData: ProductInstanceLifecycleEventData;
  eventHeader: EventHeader;
};

export type ProductInstanceLifecycleEventData = {
  __typename?: 'ProductInstanceLifecycleEventData';
  attributes?: Maybe<Array<Maybe<EventAttributes>>>;
  error?: Maybe<EventError>;
  newState: LifecycleStateType;
  oldState: LifecycleStateType;
  productInstance: EventProductInstance;
  productInstanceRelationships?: Maybe<Array<Maybe<EventProductInstanceRelationship>>>;
};

export type ProductInstanceRelationship = {
  __typename?: 'ProductInstanceRelationship';
  destinationProductInstance: ProductInstance;
  endTimestamp?: Maybe<Scalars['DateTime']>;
  productInstanceRelationshipId: Scalars['ID'];
  productRelationshipType: ProductRelationshipType;
  sourceProductInstance: ProductInstance;
  startTimestamp: Scalars['DateTime'];
};

export type ProductInstanceRelationshipInput = {
  destinationProductInstanceId: Scalars['ID'];
  endTimestamp?: InputMaybe<Scalars['DateTime']>;
  productInstanceRelationshipId: Scalars['ID'];
  productRelationshipType: ProductRelationshipType;
  sourceProductInstanceId: Scalars['ID'];
  startTimestamp?: InputMaybe<Scalars['DateTime']>;
};

export type ProductInstanceRelationshipUpsertPayload = {
  __typename?: 'ProductInstanceRelationshipUpsertPayload';
  destinationProductInstanceId: Scalars['ID'];
  endTimestamp?: Maybe<Scalars['DateTime']>;
  productInstanceRelationshipId: Scalars['ID'];
  productRelationshipType: ProductRelationshipType;
  sourceProductInstanceId: Scalars['ID'];
  startTimestamp: Scalars['DateTime'];
};

export type ProductInstanceRelationshipsFilterInput = {
  destinationProductInstance?: InputMaybe<ProductInstanceFilterInput>;
  enddated?: InputMaybe<Scalars['Boolean']>;
  relationshipType_in?: InputMaybe<Array<Scalars['String']>>;
  sourceProductInstance?: InputMaybe<ProductInstanceFilterInput>;
};

export enum ProductRelationshipType {
  Configures = 'CONFIGURES',
  DependsOn = 'DEPENDS_ON',
  /** @deprecated Use REQUIRED_BY */
  EquipmentOf = 'EQUIPMENT_OF',
  Fulfills = 'FULFILLS',
  Relocates = 'RELOCATES',
  Replaces = 'REPLACES',
  RequiredBy = 'REQUIRED_BY',
  /** @deprecated Use REQUIRED_BY */
  Requires = 'REQUIRES',
}

export type PsmOnboardProductInstanceInput = {
  characteristics?: InputMaybe<Array<InputMaybe<CharacteristicInput>>>;
  creationTimestamp: Scalars['DateTime'];
  description?: InputMaybe<Scalars['String']>;
  kind: Scalars['String'];
  lastUpdateTimestamp: Scalars['DateTime'];
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name: Scalars['String'];
  partySummary?: InputMaybe<Array<InputMaybe<PartySummaryInput>>>;
  prices?: InputMaybe<Array<InputMaybe<PriceInput>>>;
  productInstanceId: Scalars['ID'];
  productTypeId: Scalars['ID'];
  state: LifecycleStateType;
};

/** PublishLifecycleStateEvent Request */
export type PublishLifecycleStateEventInput = {
  productInstanceId: Scalars['ID'];
  state: LifecycleStateType;
};

/** PublishLifecycleStateEvent Response */
export type PublishLifecycleStateEventPayload = {
  __typename?: 'PublishLifecycleStateEventPayload';
  success?: Maybe<Scalars['Boolean']>;
};

/** Query Definitions */
export type Query = {
  __typename?: 'Query';
  _entities: Array<Maybe<_Entity>>;
  _service: _Service;
  findProductInstancesInProductInstanceGroup?: Maybe<FindProductInstancesInProductInstanceGroupPayload>;
  getAddOnsBundlesEquipment?: Maybe<GetAddOnsBundlesEquipmentPayload>;
  getCharacteristics?: Maybe<GetCharacteristicsPayload>;
  getCommand?: Maybe<GetCommandPayload>;
  getCommandNames?: Maybe<GetCommandNamesPayload>;
  getGovernmentSiteDetailsByState?: Maybe<GetGovernmentSiteDetailsByStatePayload>;
  getLocation?: Maybe<GetLocationPayload>;
  getLocationTimestamps?: Maybe<GetLocationTimestampsPayload>;
  getMacAddressesForProductInstanceIds?: Maybe<GetMacAddressesForProductInstanceIdsPayload>;
  getMetric?: Maybe<GetMetricPayload>;
  getMetricNames?: Maybe<GetMetricNamesPayload>;
  getMigratedEbiProducts?: Maybe<GetMigratedEbiProductsPayload>;
  getMigratedSmbProducts?: Maybe<GetMigratedSmbProductsPayload>;
  getPiiLocation?: Maybe<GetPiiLocationPayload>;
  getPortfolio?: Maybe<GetPortfolioPayload>;
  getPortfolioByPiCharacteristics?: Maybe<GetPortfolioByPiCharacteristicsPayload>;
  getPortfolioBySiteId?: Maybe<GetPortfolioBySiteIdPayload>;
  getProductInstanceAggregates?: Maybe<GetProductInstancesAggregatesPayload>;
  getProductInstanceEquipment?: Maybe<GetProductInstanceEquipmentPayload>;
  getProductInstanceEvents?: Maybe<GetProductInstanceEventsPayload>;
  getProductInstanceGroupEvents?: Maybe<GetProductInstanceGroupEventsPayload>;
  getProductInstanceGroups?: Maybe<GetProductInstanceGroupsPayload>;
  getProductInstanceRelationships?: Maybe<GetProductInstanceRelationshipsPayload>;
  getProductInstances?: Maybe<GetProductInstancesPayload>;
  getReconnectPortfolio?: Maybe<GetReconnectPortfolioPayload>;
  getRootPisFromMacAddresses?: Maybe<GetRootPisFromMacAddressesPayload>;
  getSuspendStatus?: Maybe<GetSuspendStatusPayload>;
};

/** Query Definitions */
export type Query_EntitiesArgs = {
  representations: Array<Scalars['_Any']>;
};

/** Query Definitions */
export type QueryFindProductInstancesInProductInstanceGroupArgs = {
  input?: InputMaybe<FindProductInstancesInProductInstanceGroupInput>;
};

/** Query Definitions */
export type QueryGetAddOnsBundlesEquipmentArgs = {
  input?: InputMaybe<GetAddOnsBundlesEquipmentInput>;
};

/** Query Definitions */
export type QueryGetCharacteristicsArgs = {
  input?: InputMaybe<GetCharacteristicsInput>;
};

/** Query Definitions */
export type QueryGetCommandArgs = {
  input?: InputMaybe<GetCommandInput>;
};

/** Query Definitions */
export type QueryGetCommandNamesArgs = {
  input?: InputMaybe<GetCommandNamesInput>;
};

/** Query Definitions */
export type QueryGetGovernmentSiteDetailsByStateArgs = {
  input?: InputMaybe<GetGovernmentSiteDetailsByStateInput>;
};

/** Query Definitions */
export type QueryGetLocationArgs = {
  input?: InputMaybe<GetLocationInput>;
};

/** Query Definitions */
export type QueryGetLocationTimestampsArgs = {
  input?: InputMaybe<GetLocationTimestampsInput>;
};

/** Query Definitions */
export type QueryGetMacAddressesForProductInstanceIdsArgs = {
  input?: InputMaybe<GetMacAddressesForProductInstanceIdsInput>;
};

/** Query Definitions */
export type QueryGetMetricArgs = {
  input?: InputMaybe<GetMetricInput>;
};

/** Query Definitions */
export type QueryGetMetricNamesArgs = {
  input?: InputMaybe<GetMetricNamesInput>;
};

/** Query Definitions */
export type QueryGetMigratedEbiProductsArgs = {
  input?: InputMaybe<GetMigratedEbiProductsInput>;
};

/** Query Definitions */
export type QueryGetMigratedSmbProductsArgs = {
  input?: InputMaybe<GetMigratedSmbProductsInput>;
};

/** Query Definitions */
export type QueryGetPiiLocationArgs = {
  input?: InputMaybe<GetPiiLocationInput>;
};

/** Query Definitions */
export type QueryGetPortfolioArgs = {
  input?: InputMaybe<GetPortfolioInput>;
};

/** Query Definitions */
export type QueryGetPortfolioByPiCharacteristicsArgs = {
  input?: InputMaybe<GetPortfolioByPiCharacteristicsInput>;
};

/** Query Definitions */
export type QueryGetPortfolioBySiteIdArgs = {
  input?: InputMaybe<GetPortfolioBySiteIdInput>;
};

/** Query Definitions */
export type QueryGetProductInstanceAggregatesArgs = {
  input?: InputMaybe<GetProductInstancesAggregatesInput>;
};

/** Query Definitions */
export type QueryGetProductInstanceEquipmentArgs = {
  input?: InputMaybe<GetProductInstanceEquipmentInput>;
};

/** Query Definitions */
export type QueryGetProductInstanceEventsArgs = {
  input?: InputMaybe<GetProductInstanceEventsInput>;
};

/** Query Definitions */
export type QueryGetProductInstanceGroupEventsArgs = {
  input?: InputMaybe<GetProductInstanceGroupEventsInput>;
};

/** Query Definitions */
export type QueryGetProductInstanceGroupsArgs = {
  input?: InputMaybe<GetProductInstanceGroupsInput>;
};

/** Query Definitions */
export type QueryGetProductInstanceRelationshipsArgs = {
  input?: InputMaybe<GetProductInstanceRelationshipsInput>;
};

/** Query Definitions */
export type QueryGetProductInstancesArgs = {
  input?: InputMaybe<GetProductInstancesInput>;
};

/** Query Definitions */
export type QueryGetReconnectPortfolioArgs = {
  input?: InputMaybe<GetReconnectPortfolioInput>;
};

/** Query Definitions */
export type QueryGetRootPisFromMacAddressesArgs = {
  input?: InputMaybe<GetRootPisFromMacAddressesInput>;
};

/** Query Definitions */
export type QueryGetSuspendStatusArgs = {
  input?: InputMaybe<GetSuspendStatusInput>;
};

export type ReactivateProductInput = {
  productInstanceId: Scalars['ID'];
};

export type ReactivateProductPayload = {
  __typename?: 'ReactivateProductPayload';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type ReconnectPortfolioProductInstance = {
  __typename?: 'ReconnectPortfolioProductInstance';
  kind?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  productInstanceId: Scalars['ID'];
  productTypeId?: Maybe<Scalars['ID']>;
  state: LifecycleStateType;
};

export type Relationship = {
  getProductInstances?: Maybe<GetProductInstancesPayload>;
  relnId: Scalars['ID'];
};

export type RelationshipInstance = Relationship & {
  __typename?: 'RelationshipInstance';
  getProductInstances?: Maybe<GetProductInstancesPayload>;
  relnId: Scalars['ID'];
  relnType: RelationshipType;
};

export type RelationshipType = {
  __typename?: 'RelationshipType';
  qualifiedName: Scalars['ID'];
};

/** removeOtherLocation */
export type RemoveOtherLocationInput = {
  locationId: Scalars['String'];
  otherLocationName: Scalars['String'];
};

export type RemoveOtherLocationPayload = {
  __typename?: 'RemoveOtherLocationPayload';
  location: Location;
  updatedPartySummaries?: Maybe<Array<PartySummary>>;
  updatedProductInstanceIds?: Maybe<Array<Scalars['String']>>;
};

export type RemoveProductInstanceGroupMembersInput = {
  members: Array<Scalars['ID']>;
  productInstanceGroupId: Scalars['ID'];
};

export type RemoveProductInstanceGroupMembersPayload = {
  __typename?: 'RemoveProductInstanceGroupMembersPayload';
  membersNotRemoved?: Maybe<Array<MemberError>>;
  membersRemoved: Array<Scalars['ID']>;
  productInstanceGroupId: Scalars['ID'];
};

/** removeRelationshipEndTimestamp Request */
export type RemoveRelationshipEndTimestampInput = {
  productInstanceRelationshipId: Scalars['ID'];
};

/** RemoveRelationshipEndTimestampPayload Response */
export type RemoveRelationshipEndTimestampPayload = {
  __typename?: 'RemoveRelationshipEndTimestampPayload';
  success: Scalars['Boolean'];
};

/** RequestDeleteCharacteristic */
export type RequestDeleteCharacteristicInput = {
  characteristics: CharacteristicInput;
  productInstanceId: Scalars['ID'];
};

export type RequestDeleteCharacteristicPayload = {
  __typename?: 'RequestDeleteCharacteristicPayload';
  error?: Maybe<ErrorPayload>;
  success?: Maybe<Scalars['Boolean']>;
};

/** RequestProductInstanceLifecycleStateChange Request */
export type RequestProductInstanceLifecycleStateChangeInput = {
  additionalAttributes?: InputMaybe<Array<InputMaybe<AdditionalAttributesInput>>>;
  productInstanceId: Scalars['ID'];
  state: LifecycleStateType;
};

/** RequestProductInstanceLifecycleStateChange Payload */
export type RequestProductInstanceLifecycleStateChangePayload = {
  __typename?: 'RequestProductInstanceLifecycleStateChangePayload';
  previousState?: Maybe<LifecycleStateType>;
  success?: Maybe<Scalars['Boolean']>;
};

/** RequestRelatedProductStateChangeInput */
export type RequestRelatedProductStateChangeInput = {
  fsiProductInstanceId: Scalars['ID'];
  relationshipType: ProductRelationshipType;
  state: LifecycleStateType;
};

export type RequestRelatedProductStateChangePayload = {
  __typename?: 'RequestRelatedProductStateChangePayload';
  productInstances: Array<Maybe<StateChangeResult>>;
};

/** UpsertCharacteristics Request */
export type RequestUpsertCharacteristicInput = {
  characteristics: CharacteristicInput;
  options?: InputMaybe<Array<CharacteristicInput>>;
  productInstanceId: Scalars['ID'];
};

/** requestUpsertGroupCharacteristic */
export type RequestUpsertGroupCharacteristicInput = {
  characteristic: CharacteristicInput;
  options?: InputMaybe<Array<CharacteristicInput>>;
  productInstanceGroupId: Scalars['ID'];
};

export type RequestedState = {
  __typename?: 'RequestedState';
  processed: Scalars['Boolean'];
  productInstanceId: Scalars['ID'];
  state: LifecycleStateType;
};

export type RequestedStateInput = {
  productInstanceId: Scalars['ID'];
  state: LifecycleStateType;
};

export type RootProduct = {
  __typename?: 'RootProduct';
  macAddress: Scalars['String'];
  product?: Maybe<ProductInstance>;
  relnId: Scalars['ID'];
};

export type Site = {
  __typename?: 'Site';
  characteristics?: Maybe<Array<Characteristic>>;
  groupId: Scalars['ID'];
  name: Scalars['String'];
  state: Scalars['String'];
  type: Scalars['String'];
};

export type SiteDetails = {
  __typename?: 'SiteDetails';
  contractId?: Maybe<Scalars['String']>;
  groupId: Scalars['ID'];
  networks: Array<Scalars['String']>;
  regions: Array<Scalars['String']>;
  salesforceEnvironment?: Maybe<Scalars['String']>;
  siteId: Scalars['String'];
  sourceAccountId?: Maybe<Scalars['String']>;
  sourceAccountName?: Maybe<Scalars['String']>;
  sourceRecordId?: Maybe<Scalars['String']>;
};

export type StateChangeResult = {
  __typename?: 'StateChangeResult';
  productInstanceId: Scalars['ID'];
  reason?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type UpdateAddressInput = {
  addressLine?: InputMaybe<Array<Scalars['String']>>;
  municipality?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
};

export type UpdateAddressLinesInput = {
  addressLines: Array<InputMaybe<Scalars['String']>>;
  locationId: Scalars['String'];
};

export type UpdateAddressLinesPayload = {
  __typename?: 'UpdateAddressLinesPayload';
  location?: Maybe<Location>;
  updatedPartySummaries?: Maybe<Array<PartySummary>>;
  updatedProductInstanceIds?: Maybe<Array<Scalars['String']>>;
};

/**
 * UpdateCharacteristicList Request
 *
 * - **REPLACES all** characteristics for this CharName with new given values \
 *   To preserve OLD values, pass alongside with NEW values to this Update Request
 */
export type UpdateCharacteristicListInput = {
  name: Scalars['String'];
  productInstanceId: Scalars['ID'];
  values: Array<Scalars['String']>;
};

export type UpdateCoordinateLatLongInput = {
  latitude: Scalars['Float'];
  locationId: Scalars['String'];
  longitude: Scalars['Float'];
};

export type UpdateCoordinateLatLongPayload = {
  __typename?: 'UpdateCoordinateLatLongPayload';
  success: Scalars['Boolean'];
  updatedPartySummaries?: Maybe<Array<PartySummary>>;
  updatedProductInstanceIds?: Maybe<Array<Scalars['String']>>;
};

export type UpdateEquipmentInput = {
  equipmentUpdates: Array<EquipmentUpdateInput>;
};

export type UpdateEquipmentPayload = {
  __typename?: 'UpdateEquipmentPayload';
  results: Array<Maybe<UpdateEquipmentResults>>;
};

export type UpdateInstallationAttributesInput = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  productInstanceId: Scalars['ID'];
};

export type UpdateInstallationAttributesPayload = {
  __typename?: 'UpdateInstallationAttributesPayload';
  errorReason?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type UpdateLocationIdsInput = {
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productInstanceId: Scalars['String'];
};

export type UpdateLocationIdsPayload = {
  __typename?: 'UpdateLocationIdsPayload';
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateMigratedEbiProductInstanceInput = {
  errorDescription?: InputMaybe<Scalars['String']>;
  phase?: InputMaybe<Scalars['String']>;
  productInstanceId?: InputMaybe<Scalars['ID']>;
  sai?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type UpdateMigratedEbiProductInstancePayload = {
  __typename?: 'UpdateMigratedEbiProductInstancePayload';
  reason?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type UpdateMigratedSmbProductInstanceInput = {
  errorDescription?: InputMaybe<Scalars['String']>;
  productInstanceId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Scalars['String']>;
};

export type UpdateMigratedSmbProductInstancePayload = {
  __typename?: 'UpdateMigratedSmbProductInstancePayload';
  reason?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type UpdateProductInstanceGroupInput = {
  newCharacteristics?: InputMaybe<Array<CharacteristicInput>>;
  newName?: InputMaybe<Scalars['String']>;
  productInstanceGroupId: Scalars['ID'];
};

export type UpdateProductInstanceGroupPayload = {
  __typename?: 'UpdateProductInstanceGroupPayload';
  productInstanceGroup: ProductInstanceGroup;
};

/** UpdateProductInstanceLifecycleState Request */
export type UpdateProductInstanceLifecycleStateInput = {
  additionalAttributes?: InputMaybe<Array<InputMaybe<AdditionalAttributesInput>>>;
  error?: InputMaybe<UpsertErrorInput>;
  productInstanceId: Scalars['ID'];
  retryError?: InputMaybe<Scalars['Boolean']>;
  state: LifecycleStateType;
};

/** UpdateProductInstanceLifecycleState Payload */
export type UpdateProductInstanceLifecycleStatePayload = {
  __typename?: 'UpdateProductInstanceLifecycleStatePayload';
  previousState?: Maybe<LifecycleStateType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateServiceLocationAddressInput = {
  address?: InputMaybe<UpdateAddressInput>;
  locationId: Scalars['String'];
};

export type UpdateServiceLocationAddressPayload = {
  __typename?: 'UpdateServiceLocationAddressPayload';
  success: Scalars['Boolean'];
  updatedPartySummaries?: Maybe<Array<PartySummary>>;
  updatedProductInstanceIds?: Maybe<Array<Scalars['String']>>;
};

/** UpsertCharacteristics Request */
export type UpsertCharacteristicsInput = {
  characteristics?: InputMaybe<Array<InputMaybe<CharacteristicInput>>>;
  error?: InputMaybe<UpsertErrorInput>;
  options?: InputMaybe<Array<CharacteristicInput>>;
  productInstanceId: Scalars['ID'];
};

/** UpsertCharacteristics Response */
export type UpsertCharacteristicsPayload = {
  __typename?: 'UpsertCharacteristicsPayload';
  error?: Maybe<UpsertErrorPayload>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpsertErrorInput = {
  category: Scalars['String'];
  code: Scalars['String'];
  errorInstanceId: Scalars['ID'];
  message?: InputMaybe<Scalars['String']>;
  severity?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
};

export type UpsertErrorPayload = {
  __typename?: 'UpsertErrorPayload';
  category: Scalars['String'];
  code: Scalars['String'];
  errorInstanceId: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  severity?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
};

export type UpsertProductInstanceGroupCharacteristicsInput = {
  characteristics?: InputMaybe<Array<CharacteristicInput>>;
  error?: InputMaybe<UpsertErrorInput>;
  options?: InputMaybe<Array<CharacteristicInput>>;
  productInstanceGroupId: Scalars['ID'];
};

export type UpsertProductInstanceGroupCharacteristicsPayload = {
  __typename?: 'UpsertProductInstanceGroupCharacteristicsPayload';
  error?: Maybe<UpsertErrorPayload>;
  productInstanceGroup: ProductInstanceGroup;
  success: Scalars['Boolean'];
};

/** UpsertProductInstances Request */
export type UpsertProductInstancesInput = {
  additionalAttributes?: InputMaybe<Array<AdditionalAttributesInput>>;
  productInstanceRelationships?: InputMaybe<Array<InputMaybe<ProductInstanceRelationshipInput>>>;
  productInstances: Array<InputMaybe<ProductInstanceInput>>;
  requestedStates?: InputMaybe<Array<RequestedStateInput>>;
};

/** UpsertProductInstances Response */
export type UpsertProductInstancesPayload = {
  __typename?: 'UpsertProductInstancesPayload';
  productInstanceRelationships?: Maybe<Array<Maybe<ProductInstanceRelationshipUpsertPayload>>>;
  productInstances?: Maybe<Array<Maybe<ProductInstance>>>;
  requestedStates?: Maybe<Array<RequestedState>>;
};

export type _Entity =
  | Characteristic
  | Currency
  | CustomerReln
  | ErrorPayload
  | Location
  | Money
  | Order
  | PartySummary
  | Price
  | Product
  | ProductInstance
  | ProductInstanceGroup
  | ProductInstanceRelationship
  | RelationshipInstance
  | RelationshipType;

export type _Service = {
  __typename?: '_Service';
  sdl?: Maybe<Scalars['String']>;
};

export type MemberError = {
  __typename?: 'memberError';
  member: Scalars['ID'];
  reason: Scalars['String'];
};

export type ShortCodeInput = {
  countryCode: Scalars['String'];
  shortCode: Scalars['String'];
};

export type UpdateEquipmentResults = {
  __typename?: 'updateEquipmentResults';
  message?: Maybe<Scalars['String']>;
  productInstanceId: Scalars['ID'];
  success: Scalars['Boolean'];
};
